import { useEffect, useState } from "react";
import { holdClock } from "../core/primitives/vendor-show";

/** How long the table stays held for the shop, ticking every second. */
export function HoldCountdown({ expiresAt }: { expiresAt: Date }) {
  const [leftMs, setLeftMs] = useState(() => expiresAt.getTime() - Date.now());

  useEffect(() => {
    const tick = () => setLeftMs(expiresAt.getTime() - Date.now());
    tick();
    const timer = window.setInterval(tick, 1_000);
    return () => window.clearInterval(timer);
  }, [expiresAt]);

  const clock = holdClock(leftMs);
  if (!clock) return <p className="text-xs text-danger">The hold ran out.</p>;
  return <p className={`text-xs ${clock.urgent ? "text-danger" : "text-muted"}`}>Held for you · {clock.text} left</p>;
}
